import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {Select} from '../../../../../../components/UI/Select'
import {SelectAsync} from '../../../../../../components/UI/SelectV2'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {SelectOption} from '../../../../../../models/utility.model'
import {formatDateType2} from '../../../../../../util/dates'
import {ClientModel, CompanyModel, UserModel} from '../../../../../central/model'
import {getUser} from '../../../../../central/services'
import {SelectModel} from '../../../../../lavanderia/model'
import {searchId, searchItemId} from '../../../../helpers/utilities'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {getGuestByIdService} from '../../../../services/guest.service'
import {MasterModel, SiteModel} from '../../../modules/models'
import {getMasterModuleService} from '../../../modules/services'
import {useBed} from '../../../../hooks/useBed'
import AditionalCamp from '../../../../../../components/UI/Form/aditionalCamp'
const FormGuest: FC = () => {
  const {currentTabItem} = useHoteleria()
  const [companies, setCompanies] = useState<CompanyModel[] | any>([])
  const [clients, setClients] = useState<ClientModel[] | any>([])
  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const [users, setUsers] = useState<UserModel[] | any>([])
  const [guestTypes, setGuestTypes] = useState<MasterModel[] | any>([])
  const [stayTypes, setStayTypes] = useState<MasterModel[] | any>([])
  const [regimenTypes, setRegimenTypes] = useState<MasterModel[] | any>([])
  const [rooms, setRooms] = useState<SelectModel[]>([])
  const [cargos, setCargos] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])
  const [modules, setModules] = useState<SelectModel[]>([])
  const [beds, setBeds] = useState<SelectModel[]>([])
  const [showModules, setShowModules] = useState<boolean>(true)
  const [turns, setTurns] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])
  const [bedOption, setBedOption] = useState<SelectOption>()
  const [roomGuest, setRoomGuest] = useState<string>()

  const {getRooms} = useRooms()
  const {getModules} = useModules()

  const {
    register,
    formState: {errors},
    control,
    setError,
    setValue,
    watch,
  } = useFormContext()

  const {getCompanies, getClients, getSites, getCamps, getMasterTable} = useCentralServices()
  const {getBeds} = useBed()
  const permanentStay = watch('tipoEstadia') === 'PERMANENTE'

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompanies(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClients(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSites(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value)
      setError('CampamentoId', {})
      await getModulesFn(data[0].value as string)
    }
    const allData = [{value: '4EsB2NAAsDA=', label: 'TODOS'}, ...data]
    setCamps(allData)
  }

  const getGuestTypesFn = async () => {
    const data = await getMasterTable('TipoHuesped', true)
    setGuestTypes(data)
  }

  const getStayTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoEstadiaHuesped',
      })
      const data = response.data.data
      const orderedData = data.sort((a, b) => {
        return a.codigo.localeCompare(b.codigo)
      })
      const mappedModuleTypes = orderedData?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setStayTypes(mappedModuleTypes)
    } catch (error) {
      setStayTypes([])
    }
  }

  const getRegimenTypesFn = async () => {
    const data = await getMasterTable('Regimen', true)
    setRegimenTypes(data)
  }

  const getModulesFn = async (campId: string) => {
    const data = await getModules({CampamentoId: campId})
    if (data.length === 1) {
      await getRoomsFn(data[0].value as string)
    }
    setModules(data)
  }

  const getRoomsFn = async (moduleId: string) => {
    try {
      const data = await getRooms({
        ModuloId: moduleId,
        isCombo: true,
      })
      setRooms(data)
    } catch (error) {
      setRooms([])
    }
  }

  const getBedsFn = async (roomId: string) => {
    const data = await getBeds({HabitacionId: roomId, isCombo: true})
    if (currentTabItem.idToEdit && roomGuest === roomId) {
      data.push(bedOption as any)
    }
    setBeds(data)
  }

  const getBedsFnCharge = async (roomId: string, bedOption: any) => {
    const data = await getBeds({HabitacionId: roomId, isCombo: true})
    let filteredData = data.filter((item) => item.EstadoCama_descripcion === 'DISPONIBLE')
    filteredData.push(bedOption)
    setBeds(filteredData)
  }

  const getCargosFn = async () => {
    const data = await getMasterTable('Cargo', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setCargos(allData)
  }

  const getTurnsFn = async () => {
    const data = await getMasterTable('Turno', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setTurns(allData)
  }

  const handleGetClientsList = async (val: any) => {
    let companyId = val ? val.value : ''
    getClientsFn(companyId)
    setValue('CompaniaId', companyId)
    setError('CompaniaId', {})
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setSites([])
    setCamps([])
  }

  const handleGetSitesList = async (val: any) => {
    let clientId = val ? val.value : ''
    getSitesFn(clientId)
    setValue('ClienteId', clientId)
    setError('ClienteId', {})
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setCamps([])
  }

  const handleGetCampsList = async (val: any) => {
    let siteId = val ? val.value : ''
    getCampsFn(siteId)
    setValue('SiteId', siteId)
    setError('SiteId', {})
    setValue('CampamentoId', '')
  }

  const handleUsersList = async (val: any) => {
    let campId = val ? val.value : ''
    getModulesFn(campId)
    setValue('CampamentoId', campId)
    setValue('Campamento_label', val.label)
    setError('CampamentoId', {})
  }

  const handleModuleChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ModuloId', value)
    getRoomsFn(value)
    setError('ModuloId', {})
    setValue('HabitacionId', '')
    setValue('CamaId', '')
    setRooms([])
    setBeds([])
  }

  const handleRoomChange = (val: any) => {
    let value = val ? val.value : ''
    getBedsFn(value)
    setValue('HabitacionId', value)
    setError('HabitacionId', {})
    setValue('CamaId', '')
    setBeds([])
    // setError('CamaId', {})
  }

  const handleStayTypeChange = (val: any) => {
    let value = val ? val.value : ''
    const idToSet = searchId(stayTypes, value, 'NO PERMANENTE')
    if (idToSet) {
      setShowModules(false)
      setValue('ModuloId', '')
      setValue('HabitacionId', '')
      setValue('tipoEstadia', 'NO PERMANENTE')
    } else {
      setShowModules(true)
      setValue('tipoEstadia', 'PERMANENTE')
    }
    setValue('TipoEstadiaId', value)
    setError('TipoEstadiaId', {})
  }

  useEffect(() => {
    getCompaniesFn()
    getGuestTypesFn()
    getStayTypes()
    getRegimenTypesFn()
    getTurnsFn()
    getCargosFn()
    setValue('tipoEstadia', 'PERMANENTE')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (watch('Campamento_label') === 'TODOS') {
      setShowModules(false)
      setValue('ModuloId', '')
      setValue('HabitacionId', '')
      const stayDefault = stayTypes.find((item: any) => item.label === 'NO PERMANENTE')?.value
      const statusDefault = guestTypes.find((item: any) => item.label === 'WORKER')?.value
      setValue('tipoEstadia', 'NO PERMANENTE')
      setValue('TipoEstadiaId', stayDefault)
      setValue('TipoHuespedId', statusDefault)
    } else {
      if (watch('tipoEstadia') === 'PERMANENTE') {
        setShowModules(true)
        setValue('ModuloId', '')
        setValue('HabitacionId', '')
        const stayDefault = stayTypes.find((item: any) => item.label === 'PERMANENTE')?.value
        setValue('tipoEstadia', 'PERMANENTE')
        setValue('TipoEstadiaId', stayDefault)
        setValue('TipoHuespedId', '')
      }
    }
  }, [watch('Campamento_label')])

  const getBedById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getGuestByIdService(idToEdit as any)
        const {
          CompaniaId,
          ClienteId,
          SiteId,
          UsuarioId,
          TipoHuespedId,
          TipoEstadiaId,
          RegimenId,
          ModuloId,
          HabitacionId,
          CamaId,
          CargoId,
          Cama_descripcion,
          CampamentoId,
          TurnoId,
          Campoadicionaltxt1,
          Campoadicionaltxt2,
          Campoadicionaltxt3,
          Campoadicionaltxt4,
          Campoadicionaltxt5,
          Campoadicionalnum1,
          Campoadicionalnum2,
          Campoadicionalnum3,
          CampoadicionalFec1,
          CampoadicionalFec2,
          Usuario_descripcion,
        } = data
        setValue('Id', idToEdit)
        setValue('CompaniaId', CompaniaId)
        setValue('ClienteId', ClienteId)
        setValue('SiteId', SiteId)
        setValue('UsuarioId', UsuarioId)
        setValue('TipoHuespedId', TipoHuespedId)
        setValue('TipoEstadiaId', TipoEstadiaId)
        setValue('RegimenId', RegimenId)
        setValue('ModuloId', ModuloId)
        setValue('HabitacionId', HabitacionId)
        setValue('CamaId', CamaId)
        setValue('CargoId', CargoId || '')
        setValue('Usuario_descripcion', Usuario_descripcion)
        setRoomGuest(HabitacionId)
        setBedOption({value: CamaId, label: Cama_descripcion})
        const bedOpt = {value: CamaId, label: Cama_descripcion}
        setValue('CampamentoId', CampamentoId)
        setValue('TurnoId', TurnoId || '')
        setValue('Campoadicionaltxt1', Campoadicionaltxt1)
        setValue('Campoadicionaltxt2', Campoadicionaltxt2)
        setValue('Campoadicionaltxt3', Campoadicionaltxt3)
        setValue('Campoadicionaltxt4', Campoadicionaltxt4)
        setValue('Campoadicionaltxt5', Campoadicionaltxt5)
        let num1 = Campoadicionalnum1 ? (Campoadicionalnum1 === 0 ? '' : Campoadicionalnum1) : ''
        let num2 = Campoadicionalnum2 ? (Campoadicionalnum2 === 0 ? '' : Campoadicionalnum2) : ''
        let num3 = Campoadicionalnum3 ? (Campoadicionalnum3 === 0 ? '' : Campoadicionalnum3) : ''
        setValue('Campoadicionalnum1', num1)
        setValue('Campoadicionalnum2', num2)
        setValue('Campoadicionalnum3', num3)
        setValue('CampoadicionalFec1', formatDateType2(CampoadicionalFec1))
        setValue('CampoadicionalFec2', formatDateType2(CampoadicionalFec2))
        getClientsFn(CompaniaId as any)
        getSitesFn(ClienteId as any)
        getModulesFn(CampamentoId as any)
        if(ModuloId) {getRoomsFn(ModuloId as any)}
        if(HabitacionId){getBedsFnCharge(HabitacionId as any, bedOpt)}
        const isNoPermanent = searchItemId(stayTypes, TipoEstadiaId as any, 'NO PERMANENTE')
        if (isNoPermanent) {
          setShowModules(false)
          setValue('tipoEstadia', 'NO PERMANENTE')
        } else {
          setShowModules(true)
          setValue('tipoEstadia', 'PERMANENTE')
        }

        getCampsFn(SiteId as any)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit && stayTypes.length > 0) {
      getBedById()
    }
  }, [currentTabItem.idToEdit, stayTypes])

  let isDisabled = false //currentTabItem.idToEdit ? true : false

  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const response = await getUser(
        {isCombo: true, campamentoId: watch('CampamentoId') || null, BuscaTexto: inputValue},
        1,
      )
      if (!response.data.error) {
        const data = response.data.data
        const mappedUsers = data?.map((user) => ({
          value: user.id,
          label: `${user.nombres || ''} ${user.apellidos || ''} ${user.numeroDocumento || ''}`,
          ...user,
        }))
        return mappedUsers
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const handleGetName = (e: any) => {
    setValue('Usuario_descripcion', e.label)
    setValue('UsuarioId', e.value)
    setError('UsuarioId', {})
  }

  return (
    <div className='sdx_form card p-4'>
      <h4>Datos del huésped</h4>
      <div className='d-flex row'>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Compañía'
            name='CompaniaId'
            data={companies}
            disabled={isDisabled}
            onChangeValue={handleGetClientsList}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Cliente'
            name='ClienteId'
            data={clients}
            disabled={isDisabled}
            onChangeValue={handleGetSitesList}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Site'
            name='SiteId'
            data={sites}
            disabled={isDisabled}
            onChangeValue={handleGetCampsList}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Campamento'
            name='CampamentoId'
            data={camps}
            disabled={isDisabled}
            onChangeValue={handleUsersList}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <div className='d-flex'>
            <label className='required'>Usuario</label>
          </div>
          <SelectAsync
            loadOptions={loadOptions as any}
            name='UsuarioId'
            disabled={!watch('CampamentoId')}
            value={
              watch('UsuarioId')
                ? {
                    value: watch('UsuarioId') || '',
                    label: watch('Usuario_descripcion') || '',
                  }
                : null
            }
            onChangeValue={handleGetName}
            textPlaceholder='Buscar Usuario...'
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Estatus'
            name='TipoHuespedId'
            data={guestTypes}
            disabled={watch('Campamento_label') === 'TODOS'}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Tipo de estadía'
            name='TipoEstadiaId'
            data={stayTypes}
            disabled={watch('Campamento_label') === 'TODOS'}
            onChangeValue={handleStayTypeChange}
            required
          />
        </div>
        <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Cargo' name='CargoId' data={cargos} required />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <SelectWrapper labelText='Turno' name='TurnoId' data={turns} required />
        </div>
        {showModules ? (
          <>
            <div className='mb-2 col-sm-12 col-lg-3'>
              <label className={permanentStay ? 'required' : ''}>Módulo:</label>
              <Select
                control={control}
                name='ModuloId'
                data={modules}
                errors={errors}
                onChangeValue={handleModuleChange}
              />
            </div>
            <div className='mb-2 col-sm-12 col-lg-3'>
              <label className={permanentStay ? 'required' : ''}>Habitación:</label>
              <Select
                control={control}
                name='HabitacionId'
                data={rooms}
                errors={errors}
                onChangeValue={handleRoomChange}
              />
            </div>
            <div className='mb-2 col-sm-12 col-lg-3'>
              <label className={permanentStay ? 'required' : ''}>Cama:</label>
              <Select control={control} name='CamaId' data={beds} errors={errors} />
            </div>
          </>
        ) : (
          <></>
        )}
        <div className='col-sm-12 col-lg-3'>
          <SelectWrapper
            labelText='Régimen'
            name='RegimenId'
            data={regimenTypes}
            disabled={isDisabled}
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalCamp module='hoteleria' />
    </div>
  )
}

export {FormGuest}
